import MockAdapter from 'axios-mock-adapter'
// ** axios
import {axiosInstance} from '@configs/axiosinstance.js'

const mock = new MockAdapter(axiosInstance)

export default mock
